import { isExpired, decodeToken } from 'react-jwt';
import { path_dashboard } from 'config';

class SessionFactory {
    static validation(){
        if(!localStorage.getItem('sessionData')) return null;
        const sessionData = JSON.parse(localStorage.getItem('sessionData'));
        if(!sessionData.token) return null;
        //decode jwt && compare
        const tokenIsExpired = isExpired(sessionData.token);
        if(tokenIsExpired) return null;
        
        sessionData.path_dashboard = path_dashboard;
        return sessionData;
    }
    static save(sessionData){
        localStorage.setItem('sessionData', JSON.stringify(sessionData));
    }
    static initialize(sessionToken,tokenLog,iniciotimeSession,scope) {
        const jwt = decodeToken(sessionToken);
        const sessionData = {
            token: sessionToken, 
            fullname: (!!jwt.nombres && !!jwt.apellidos) ? `${jwt.nombres} ${jwt.apellidos}`: null, 
            firstname: jwt.nombres, 
            lastname: jwt.apellidos,
            docType: 9,
            docNumber: null,
            phone: null,
            email: jwt.email,
            bonus: jwt.bonus,
            welcome: jwt.welcome,
            tokenLogUsuario:tokenLog,
            inicioSession:iniciotimeSession,
            scope:scope
        };
        return sessionData;
    }
    static setItemSession(index, value){
        let sessionData = {};
        if(localStorage.getItem('sessionData'))
            sessionData = JSON.parse(localStorage.getItem('sessionData'));
        localStorage.setItem('sessionData', JSON.stringify({...sessionData, [index]:value}));
    }
    static getItemSession(index = ''){
        let sessionData = {};
        if(localStorage.getItem('sessionData'))
            sessionData = JSON.parse(localStorage.getItem('sessionData'));
        return sessionData[index] ? sessionData[index] : '';
    }
    static authenticatedUserJwt(sessionToken) {
        const jwt = decodeToken(sessionToken);
        return jwt;
    }
    static saveUpdateTries(payload,session){
        let updateTrie;
        if(session=='login'){
             updateTrie={
                numberTrie:payload.updateTrie,
                showUpdateData:false
            };
    

        }else if(session=='update') {
             updateTrie={
                numberTrie:payload.updateTrie,
                showUpdateData:true
            };
    


        }

        
        localStorage.setItem('updateTries',JSON.stringify(updateTrie));
        if(payload.updateTrie<3){
            localStorage.setItem('loginData',JSON.stringify(payload));
        }
    }
    static resetloginData(){
        localStorage.removeItem('loginData');
    }
    static resetUpdateTries(){
        this.resetloginData();
        localStorage.removeItem('updateTries');

    }
    static getUpdateTries(index=''){
        let updateTrie={};
        if(localStorage.getItem('updateTries')){
            updateTrie=JSON.parse(localStorage.getItem('updateTries'));
            return updateTrie[index]?updateTrie[index]:'';

        }
        return updateTrie;


    }
    static setUpdateTries(key, value) {
        let updateTries = {};
        if (localStorage.getItem('updateTries')) {
            updateTries = JSON.parse(localStorage.getItem('updateTries'));
        }
        updateTries[key] = value; // Establecer el valor para la clave proporcionada
        localStorage.setItem('updateTries', JSON.stringify(updateTries));
    }
    static getLoginData(){
        let dataUpdate={};
        let loginData=null;

        if(localStorage.getItem('loginData')){
            dataUpdate=JSON.parse(localStorage.getItem('loginData'));
            let tokenLogin=this.getItemSession('tokenLogUsuario');
            loginData = {
                loginApp: dataUpdate,
                login: tokenLogin
            };

        }
        return loginData;

    }
}

export default SessionFactory;